import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://oscxjzcyqinjkqbcrbrl.supabase.co'
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlhdCI6MTYyNjI2ODcxOSwiZXhwIjoxOTQxODQ0NzE5fQ.hByKFIM06xTXaSokSo9MrimiHZeEj58aeZe3bhk8TI0'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
